
import React from 'react';
import Radio from '@mui/material/Radio';
import './radioCustom.css';

const RadioCustom = (props) => {
  return <Radio {...props} className={`custom-radio ${props.className || ''}`} />;
};

export default RadioCustom;
